import { useEffect, useRef, useState } from "react";

export function useUnreadChat({ chatCount, showTab }) {
    const [unreadChat, setUnreadChat] = useState(0);
    const prevChatCountRef = useRef(0);

    useEffect(() => {
        const currentCount = chatCount;
        const prevCount = prevChatCountRef.current;

        if (currentCount > prevCount && showTab !== "chat") {
            setUnreadChat((prev) => prev + (currentCount - prevCount));
        }

        prevChatCountRef.current = currentCount;
    }, [chatCount, showTab]);

    return { unreadChat, setUnreadChat };
}